
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxCastres = () => {
  return (
    <CityMetauxPage
      cityName="Castres"
      departmentName="Tarn"
      departmentCode="81"
      region="Occitanie"
      description="Centre industriel historique du Tarn, Castres bénéficie de notre expertise dans le rachat de métaux issus de l'industrie textile et de la pharmacie."
      specialities={[
        "Métaux de l'industrie textile",
        "Équipements pharmaceutiques et chimiques",
        "Métaux de précision et alliages",
        "Ferraille urbaine et industrielle"
      ]}
      nearbyAreas={[
        "Mazamet", "Labruguière", "Réalmont", "Lautrec", "Vielmur-sur-Agout", "Brassac"
      ]}
      heroImage="https://images.unsplash.com/photo-1466442929976-97f336a657be?w=1280&q=80"
    />
  );
};

export default AchatMetauxCastres;
